export default __webpack_public_path__ + "static/media/liku_icon.bf937c87.svg";